module.exports = __webpack_public_path__ + "static/img/analysis-analytics-business.e0c14bf.jpg";